// extracted by mini-css-extract-plugin
export var card = "_76-0";
export var failedIcon = "_76-4";
export var failedIconBadge = "_76-3";
export var icon = "_76-1";
export var successIcon = "_76-2";